'use client';

import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import {
  DD_CLIENT_TOKEN,
  DD_ENV_NAME,
  DD_SERVICE_NAME,
  DD_SITE_URL,
} from 'helpers/constants';

export const useDataDogLogging = () => {
  useEffect(() => {
    if (!DD_CLIENT_TOKEN) {
      console.info(
        'Datadog Browser SDK: "Client Token is not configured, we will not send any data."',
      );
      return;
    }
    datadogLogs.init({
      clientToken: `${DD_CLIENT_TOKEN}`,
      env: `${DD_ENV_NAME}`,
      site: `${DD_SITE_URL}`,
      forwardConsoleLogs: ['error', 'info', 'warn'],
      sessionSampleRate: 100,
      service: `${DD_SERVICE_NAME}`,
    });
  }, []);
};
